import { render, staticRenderFns } from "./LayerInfoCard.vue?vue&type=template&id=56ed4589"
import script from "./LayerInfoCard.vue?vue&type=script&lang=js"
export * from "./LayerInfoCard.vue?vue&type=script&lang=js"
import style0 from "./LayerInfoCard.vue?vue&type=style&index=0&id=56ed4589&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports